<h2 mat-dialog-title>Consultant notes</h2>

<div mat-dialog-content>
  @if (data.studentName) {
    <div class="tw:text-[13px] tw:font-semibold tw:text-[#333] tw:mb-3">{{ data.studentName }}</div>
  }

  <label class="field__label">Notes</label>
  <textarea class="field__control tw:w-full" [(ngModel)]="notes" rows="5" placeholder="Add consultant notes…"></textarea>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()">Save</button>
</div>
